import { mapState, mapActions } from 'vuex';

import { useDataLoading } from '@mixins/factories';

import PrintProviderEditor from '../../_components/printProviderEditor';

const dataLoadingOptions = {
  getterName: 'getAllPlugins',
  contentName: 'plugins',
  searchable: false,
  paged: false,
};

const pluginsHeaders = Object.freeze([
  { text: 'Vendor', value: 'vendor' },
  { text: '', value: 'actions', width: '5%' },
]);

export default {
  name: 'PrintProviders',
  mixins: [
    useDataLoading(dataLoadingOptions),
  ],
  components: {
    PrintProviderEditor,
  },
  data() {
    return {
      pluginsHeaders,
      editedPlugin: {},
      editorDialog: false,
      isEditorCreateMode: true,
    };
  },
  computed: {
    ...mapState('printProviders', ['plugins']),
  },
  methods: {
    ...mapActions('printProviders', ['getAllPlugins']),
    setEditedPlugin(plugin) {
      this.editedPlugin = plugin;
      this.isEditorCreateMode = false;
      this.editorDialog = true;
    },
  },
};
